module.exports = __webpack_public_path__ + "media/images/home/bg-5-99ad4712d39dec17080547590e561297.png";